import { Controller } from "@hotwired/stimulus";
import "../scripts/selects";

const ESC_KEY = "Escape";
export default class extends Controller {
  static targets = ["modal"];

  initialize() {}

  connect(e) {
    super.connect();
    this.setPaginationInSubmitForm();
    initializeDatePicker();
    initializeSelects();
  }

  close() {
    var modal = document.getElementById("modal");
    modal.innerHTML = "";
  }

  closeWithKeyboard(e) {
    if (e.code == ESC_KEY) {
      this.close();
    }
  }

  closeBackground(e) {
    if (e && e.target !== this.modalTarget) {
      return;
    }

    this.close();
  }

  hideOnSubmit(event) {
    this.close();
    // if (event.detail.success) {
    //   this.close();
    // }
  }

  setPaginationInSubmitForm() {
    const form = document.querySelector("#default-modal form");
    if (!form.action.includes("page")) {
      form.action = form.action + this.getPageQuery();
    }
  }

  getPageQuery() {
    const currentUrl = new URL(window.location);
    const page = currentUrl.searchParams.get("page");
    return page ? `?page=${page}` : "";
  }
}
